
    import './styles.scoped.css';
    export default {
  "icon-shake": "awsui_icon-shake_1cbgc_iwhmb_5",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_iwhmb_1",
  "container-fade-in": "awsui_container-fade-in_1cbgc_iwhmb_33",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_iwhmb_1",
  "uxdg-inverted": "awsui_uxdg-inverted_1cbgc_iwhmb_55",
  "root": "awsui_root_1cbgc_iwhmb_59",
  "status-error": "awsui_status-error_1cbgc_iwhmb_66",
  "status-warning": "awsui_status-warning_1cbgc_iwhmb_69",
  "status-success": "awsui_status-success_1cbgc_iwhmb_72",
  "status-info": "awsui_status-info_1cbgc_iwhmb_75",
  "status-stopped": "awsui_status-stopped_1cbgc_iwhmb_78",
  "status-pending": "awsui_status-pending_1cbgc_iwhmb_81",
  "status-in-progress": "awsui_status-in-progress_1cbgc_iwhmb_84",
  "status-loading": "awsui_status-loading_1cbgc_iwhmb_87",
  "color-override-red": "awsui_color-override-red_1cbgc_iwhmb_90",
  "color-override-grey": "awsui_color-override-grey_1cbgc_iwhmb_93",
  "color-override-blue": "awsui_color-override-blue_1cbgc_iwhmb_96",
  "color-override-green": "awsui_color-override-green_1cbgc_iwhmb_99",
  "icon": "awsui_icon_1cbgc_iwhmb_5",
  "container": "awsui_container_1cbgc_iwhmb_33"
};
  